import { EntityGet } from 'data/firestore/types';
import { Webhooks } from 'data/firestore/webhooks/types';

const checkFilters = ({
    value,
    filterValues,
    filterNames,
}: {
    value: EntityGet<Webhooks>,
    filterValues: Record<string, unknown>;
    filterNames: string[],
}) => filterNames.every(
    (filterName) => {
        const filterValue = filterValues[filterName];

        if (filterValue === null) return true;

        if (filterName === 'search') {
            const { endpoint, description = '' } = value;
            const term = (filterValue as string).toLowerCase().trim();
            return (
                endpoint.toLowerCase().includes(term)
                || description.toLowerCase().includes(term)
            );
        }

        if (filterName === 'events') {
            if ((filterValue as string).length > 0) {
                return (filterValue as string).split(',').some(
                    (event: string) => value.events.includes(event),
                );
            }
        }

        return true;
    },
);

export default checkFilters;
